<template>
  <section id="products">
    <div class="holder" v-if="holder"></div>

    <div v-else>
      <PageIntro title="Produtos" :notbarproduct="true" />
      <CatCarousel
        v-if="active"
        :pages="pages"
        :products="products"
        :product="true"
        :categories="cat"
        :big-img="true"
      />
      <div
        v-else-if="banner !== null"
        class="categorie-banner"
        :style="{ backgroundImage: `url('${banner.permalink}')` }"
      ></div>
      <div class="page-scroll" ref="pageScroll"></div>
      <div class="container">
        <h3 class="page-title">{{ $root.commonTexts["produto.titulo"] }}</h3>
        <div class="products">
          <router-link
            :to="{
              name: 'produto',
              params: { id: product.friendly_url || product.id },
            }"
            class="product"
            v-for="product in products"
            :key="product.id"
          >
            <div class="product__cart">
              <img src="@/assets/icons/tend-cart.svg" alt="" />
            </div>
            <!--                        <img v-if="product.images.length" class="product__img" :src="product.images[0].permalink"-->
            <!--                             alt="">-->
            <lazy-image
              v-if="product.images.length"
              class="product__img"
              :image="product.images[0]"
            />
            <div class="product__info">
              <h3 class="product__name">{{ product.name }}</h3>
              <span class="product__id">Ref: {{ product.ref }}</span>
            </div>
          </router-link>
        </div>
      </div>

      <div class="page">
        <div
          class="ball"
          :class="{ active: page === index + 1 }"
          @click="fetchPage(index + 1)"
          v-for="(currentPage, index) in pages"
          :key="currentPage + 'pagination' + index"
        >
          {{ index + 1 }}
        </div>
      </div>

      <TendenciesCarousel :content="productCarousel" />
    </div>
  </section>
</template>

<script>
import PageIntro from "../components/Shared/PageIntro";
import CatCarousel from "../components/Shared/CatCarousel";
import TendenciesCarousel from "../components/Shared/TendenciesCarousel";
import LazyImage from "../components/Shared/LazyImage";
export default {
  name: "Products",
  props: ["id"],
  data() {
    return {
      holder: true,
      cat: [],
      products: [],
      pages: null,
      productCarousel: [],
      active: null,
      banner: null,
      page: 1,
      categorie: null,
    };
  },
  methods: {
    fetchCarousel() {
      axios.get("/productdestc").then((r) => {
        this.productCarousel = r.data.data;
      });
    },
    fetchCategories() {
      axios.get("/categories").then((r) => {
        this.cat = r.data;
        if ("id" in this.$route.params) {
          this.holder = false;
          return;
        }
        this.fetchProducts();
        this.holder = false;
      });
    },
    fetchProducts() {
      if (this.id) {
        axios
          .get(
            `/product?per-page=12&ativo=1&categoria=${this.id}&page=${this.page}`
          )
          .then((r) => {
            this.pages = r.data.last_page;
            this.products = r.data.data;
          });
      }
      this.lastRouteToLS();
    },
    fetchPage(id) {
      this.$router.replace(`/produtos/${this.categorie}/${id}`);
      this.$refs.pageScroll.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    },
    lastRouteToLS() {
      this.$root.lastRoute = this.$route.fullPath;
      window.localStorage.setItem("lastRoute", this.$root.lastRoute);
    },
  },
  watch: {
    "$route.params": {
      handler: function (v) {
        const page = parseInt(v.page);
        if (!isNaN(page)) {
          this.page = page;
        }
        this.categorie = this.$route.params.id;
        this.fetchProducts();
      },
      immediate: true,
    },
  },
  mounted() {
    this.fetchCategories();
    this.fetchCarousel();
    document.title = "Fibrillare - Produtos";
    axios.get(`/categories/${this.categorie}`).then((r) => {
      this.active = r.data.ativo;
      this.banner = r.data.banner;
    });
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  },
  components: {
    PageIntro,
    CatCarousel,
    TendenciesCarousel,
    LazyImage,
  },
};
</script>

<style lang="scss" scoped>
.products {
  display: flex;
  flex-wrap: wrap;
  margin-left: -15px;
  margin-right: -15px;
}

.categorie-banner {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  max-width: 1140px;
  height: 100px;
  margin: 40px auto;
}

.product__info {
  position: relative;
  flex-grow: 1;
  align-self: flex-end;
  width: 100%;
}

.product {
  margin: 0 10px;
  flex-shrink: 0;
  width: 270px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  border: 1px solid transparent;
  position: relative;

  &:hover {
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  &__cart {
    transition: all 0.2s;
    opacity: 0;
    transform: translate3d(20px, 0, 0);
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  &__img {
    object-fit: contain;
    width: 228px;
    height: auto;
    margin-top: 30px;
    margin-bottom: 10px;
    overflow: hidden;
  }

  &__name {
    margin-bottom: 10px;
    font-family: "Open Sans";
    font-size: 1rem;
    font-weight: 600;
    color: #2b2b2b;

    &:first-letter {
      text-transform: uppercase;
    }
  }

  &__id {
    font-family: "Encode Sans";
    font-size: 0.75rem;
    color: #4d4d4d;
  }
}

.product:hover .product__cart {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}

@media only screen and (max-width: 1200px) {
  .products {
    justify-content: center;
  }
}

@media only screen and (min-width: 600px) {
  .categorie-banner {
    height: 225px;
  }
}

@media only screen and (max-width: 1024px) {
  .product__cart {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@media only screen and (max-width: 767px) {
  .product {
    border: none;

    &:hover {
      border: none;
    }
  }
}
</style>
